import { platform } from "~/platform/socket";
import { DateCategory, DateEvent } from "../types/date";
import gql from "graphql-tag";

export async function getDateData() {

	const query = gql`
		query {
			dateCategories {
				id
				title
				color
			}
			dateEvents {
				id
				title
				content
				startTime
				endTime
				isFullDay
				category {
					id
					color
					title
				}
			}
		}
	`;

	const { dateCategories, dateEvents } = await platform.query(query) as {
		dateEvents: DateEvent[];
		dateCategories: DateCategory[];
	};

	return {
		dateCategories,
		dateEvents: dateEvents.map(event => ({
			...event,
			startTime: new Date(event.startTime),
			endTime: new Date(event.endTime)
		}))
	};
}